export enum Environment {
  Development = "development",
  Production = "production",
}
interface AppConfig {
  IS_DEV: boolean;
  SERVER_URL: string;
  HEDERA_EXPLORER_PREFIX: string;
  CONTRACT_ID: string;
  FRONTEND_URL: string;
}

let appConfig: AppConfig;
const ENV = process.env.REACT_APP_APP_ENV_PROD;

console.log("ENV:::::", ENV, process.env.REACT_APP_AMPLIFY_APP_ID_PROD);

if (ENV === Environment.Development) {
  appConfig = {
    IS_DEV: true,
    SERVER_URL: "https://api.certify-dev.kpmg.in",
    FRONTEND_URL: "http://localhost:3000",
    HEDERA_EXPLORER_PREFIX: `https://hashscan.io/testnet`,
    CONTRACT_ID: "dheeraj7210.testnet",
  };
} else if (ENV === Environment.Production) {
  console.log("Loading Production config");
  appConfig = {
    IS_DEV: false,
    SERVER_URL: "https://api.mycredentials.kpmg.in",
    FRONTEND_URL: "https://app.mycredentials.kpmg.in",
    HEDERA_EXPLORER_PREFIX: `https://hashscan.io/mainnet`,
    CONTRACT_ID: "dheeraj7210.testnet",
  };
} else {
  console.log("WARNING: REACT_APP_APP_ENV_PROD is not set. Defaulting to Production config.");
  appConfig = {
    IS_DEV: false,
    SERVER_URL: "",
    FRONTEND_URL: "",
    HEDERA_EXPLORER_PREFIX: ``,
    CONTRACT_ID: "",
  };
}

export default appConfig;
